// Hostname gate for the demo shell.
//
// The workspace shell serves my.symbols.app for real, signed-in users AND
// demo.symbols.app / dev.demo.symbols.app for unauthed visitors who want a
// live tour. The ONLY difference is the auth bounce: on a demo host an
// unauthed visitor lands on the branded `/demo` email-gate instead of the
// real /login. `isDemoHost()` is the single signal that switches that
// behavior — read by `redirectIfUnauthed` (auth.js) and the shell entry.
//
// SSR-guarded (returns false when there's no `window`) and dependency-free so
// it's safe to call at module-load time during the initial parse, before any
// component mounts.
//
// Local simulation (no DNS needed): set `localStorage.symbols_force_demo='1'`
// (persists across reloads) OR append `?demo=1` to any URL (one visit). Either
// makes the shell behave exactly as it would on demo.symbols.app.
export const isDemoHost = () => {
  if (typeof window === 'undefined') return false
  try {
    // Real demo hostnames — matches BOTH `demo.symbols.app` and the dev
    // subdomain `dev.demo.symbols.app` (the `(^|\.)` prefix covers any
    // leading label, anchored to `.demo.symbols.app` at the end).
    const host = window.location.hostname || ''
    if (/(^|\.)demo\.symbols\.app$/.test(host)) return true
    // Test overrides — let any host simulate the demo gate locally.
    if (window.localStorage.getItem('symbols_force_demo') === '1') return true
    if ((window.location.search || '').includes('demo=1')) return true
  } catch (_) {
    // localStorage / location may throw in sandboxed contexts — treat as
    // "not a demo host" so production my.symbols.app is never gated by accident.
  }
  return false
}
